/**
 * 📦 V2 Withdrawals + Balances API clients
 * Rotas /api/v2/withdrawals e /api/v2/balances
 */

import v2Api from './index';

export const withdrawalsV2API = {
  /** Solicita saque. Body: { amount_cents, bank_account_id, user_notes? } */
  request: (data) => v2Api.post('/withdrawals', data),

  /** Lista do user autenticado. Query: limit, offset, status */
  listMine: (params = {}) => v2Api.get('/withdrawals/me', { params }),

  /** Admin: lista todos. */
  listAll: (params = {}) => v2Api.get('/withdrawals', { params }),

  findById: (id) => v2Api.get(`/withdrawals/${id}`),

  // Admin actions
  approve: (id, body = {}) => v2Api.post(`/withdrawals/${id}/approve`, body),
  reject: (id, body) => v2Api.post(`/withdrawals/${id}/reject`, body),
  markPaid: (id, body = {}) => v2Api.post(`/withdrawals/${id}/mark-paid`, body),
  markFailed: (id, body) => v2Api.post(`/withdrawals/${id}/mark-failed`, body),
};

export const balancesV2API = {
  me: () => v2Api.get('/balances/me'),
  movements: (params = {}) => v2Api.get('/balances/me/movements', { params }),
  releaseDue: (params = {}) => v2Api.post('/balances/release-due', null, { params }),

  /** Configuração financeira do usuário (release days, mínimo saque, antecipação) */
  myConfig: () => v2Api.get('/balances/me/config'),

  /** Antecipa todas comissões pending de uma venda. Body: { sale_id } */
  advance: (saleId) => v2Api.post('/balances/advance', { sale_id: saleId }),
};

export default withdrawalsV2API;
